<script setup>
import {
  getCheckList,
  onLineRecordList,
  offLineRecordList,
  deleteMedicalRecord
} from '@/api/HealthRecord/index.js'
import { ref, watch, createVNode, reactive, computed, defineProps } from 'vue'
import { useStore } from 'vuex'
import { columnsOnline, columnsOffline, columnsCheckList } from './Column.js'
import RecordDetail from '@/components/TheDetail'
import medicalRecordsPoup from '@/views/HealthRecord/HealthInfo/common/medicalRecordsPoup.vue'
import { calcDiagnosis } from '@/utils/index'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { Modal } from 'ant-design-vue'
import checklistDetail from '@/views/HealthRecord/checklistDetail.vue'
import moment from 'moment'
import { message } from 'ant-design-vue'

const store = useStore()
const props = defineProps({
  ucUserId: {
    type: Number,
    default: null
  },
  mode: {
    // read 表示只读模式，工单详情进来为只读模式，不允许编辑
    type: String,
    default: ''
  },
  ucDoctorId: {
    type: Number,
    default: null
  }
})
const activedTarget = {
  onLineRecord: {
    method: onLineRecords,
    columns: columnsOnline,
    detailMethod: onOperation
  },
  offLineRecord: {
    method: offLineRecords,
    columns: columnsOffline,
    detailMethod: onOperation
  },
  checkListRecord: {
    method: checkListRecords,
    columns: columnsCheckList,
    detailMethod: goCheckDetail
  }
}
const ucPatientId = computed(() => {
  return props?.ucUserId || store?.state?.workOrder?.workOrderGroupInfo?.patientInfo?.ucUserId || ''
})
const ucDoctorId = computed(() => store.state.workOrder.workOrderGroupInfo.doctorInfo.ucUserId)
const loading = ref(false)
// 上传病历显示隐藏
const UploadRecordVisible = ref(false)
// 门诊病历ID
const UploadRecordId = ref('')
const data = reactive({
  // 分页器
  pagination: {
    current: 1,
    pageSize: 10,
    showQuickJumper: true,
    showSizeChanger: true,
    total: 100,
    showTotal: () => {}
  },
  // 表格
  table: [],
  columns: columnsOnline
})
const query = ref({
  ucDoctorId,
  ucPatientId,
  reserveEntry: 3
})

const uploadOffLineRecord = () => {
  UploadRecordVisible.value = true
  UploadRecordId.value = ''
}
// 编辑门诊病历
const toEdit = e => {
  UploadRecordId.value = e.id
  UploadRecordVisible.value = true
}
// 上传门诊病历成功回调
const refreshOffLineRecord = () => {
  UploadRecordVisible.value = false
  onPageOrSize({})
}
// 上传门诊病历取消回调
const onClose = () => {
  UploadRecordVisible.value = false
}
const setTime = time => {
  return moment(time).format('YYYY-MM-DD')
}
// 获取线上病历
function onLineRecords() {
  onLineRecordList({
    ucPatientId: ucPatientId.value,
    pageNo: data.pagination.current,
    pageSize: data.pagination.pageSize
  })
    .then(res => {
      data.table = res.list
      data.pagination.total = res.totalCount
      data.pagination.showTotal = () => `共${res.totalCount}条`
    })
    .finally(() => (loading.value = false))
}
// 获取门诊病历
function offLineRecords() {
  const params = {
    ucPatientId: ucPatientId.value,
    pageNo: data.pagination.current,
    pageSize: data.pagination.pageSize,
    type: 2
  }
  const ucId = props.mode ? props.ucDoctorId : ucDoctorId.value
  ucId && (params.ucDoctorId = ucId)

  offLineRecordList(params)
    .then(res => {
      const paramsList = res.list.map(item => {
        const { beginTime = '', endTime = '', medicineCycle } = item.prescriptionInfo || {}
        // item.patientPermission = item.patientPermission === 1 ? '是' : '否'
        if (item.prescriptionInfo) {
          item.prescriptionInfo.beginTime = beginTime ? setTime(beginTime) : '--'
          item.prescriptionInfo.endTime = endTime ? setTime(endTime) : '--'
          item.prescriptionInfo.medicineCycle = medicineCycle ? medicineCycle + '天' : '--'
        }
        return {
          ...item,
          ...item.prescriptionInfo
        }
      })
      data.table = paramsList
      data.pagination.total = res.totalCount
      data.pagination.showTotal = () => `共${res.totalCount}条`
    })
    .finally(() => (loading.value = false))
}
// 获取检查单
function checkListRecords() {
  const params = {
    pageIndex: data.pagination.current,
    pageSize: data.pagination.pageSize,
    patientId: ucPatientId.value
  }
  getCheckList(params)
    .then(res => {
      const { list, totalCount } = res[0]
      data.table = list
      data.pagination.total = totalCount
      data.pagination.showTotal = () => `共${totalCount}条`
    })
    .finally(() => (loading.value = false))
}
// 检查单详情
const chekcParams = reactive({
  visible: false,
  checklistId: ''
})
// 检查单详情
function goCheckDetail({ record }) {
  chekcParams.visible = true
  chekcParams.checklistId = record.checklistId
}

function getTable() {
  loading.value = true
  data.table = []
  activedTarget[recordType.value].method()
}
// 头部切换的 radio 选择模块
const recordType = ref('onLineRecord')
watch(
  recordType,
  type => {
    onPageOrSize({ current: 1 })
    data.columns = activedTarget[type].columns
  },
  { immediate: true }
)

// 点击查看详情后的操作
const visible = ref(false)
// 病历ID详情数据
const recordId = ref('')
// 操作类型
const operateType = ref('')
// 患者PID
const pid = ref('')
// 医院ID
const hospitalId = ref(null)
// 打开详情页
function onOperation(data) {
  visible.value = true
  recordId.value = data.record.id
  operateType.value = data.record.operateType
  pid.value = data.record.pid
  hospitalId.value = data.record.hospitalId
}
function goDetail(data) {
  activedTarget[recordType.value].detailMethod(data)
}
//改变当前页 和 改变页码值
function onPageOrSize({ current = 1, pageSize = 10 }) {
  data.pagination.pageSize = pageSize
  data.pagination.current = current
  getTable()
}
// 判断能否编辑门诊病历
const getPermission = (record, key) => {
  // 允许编辑：预约单非终态+健管角色上传的 + 非只读模式
  const { createType, supplementMedicalRecordOperationVO: operation } = record
  const updatePermission = !!operation?.[key]
  return !props.mode && createType === 4 && updatePermission
}
// 删除门诊病历
const deleteRecord = record => {
  Modal.confirm({
    title: '确定删除诊疗记录',
    icon: createVNode(ExclamationCircleOutlined),
    content: '删除此诊疗记录后，所有相关复诊预约将同步失效，且操作不可撤销，请您确认是否执行删除？',
    okText: '确认',
    cancelText: '取消',
    centered: true,
    onOk: () => {
      deleteMedicalRecord({ patientDiseaseId: record.id }).then(() => {
        message.success('操作成功')
        onPageOrSize({})
      })
    },
    onCancel: () => {
      //
    }
  })
}
</script>
<template>
  <div class="medical-record">
    <!-- 头部切换 -->
    <header class="header">
      <a-radio-group v-model:value="recordType" button-style="solid">
        <a-space>
          <a-radio-button value="onLineRecord">线上病历</a-radio-button>
          <a-radio-button value="offLineRecord">门诊病历</a-radio-button>
          <a-radio-button value="checkListRecord">检查表单</a-radio-button>
        </a-space>
      </a-radio-group>
      <a-button
        v-show="recordType === 'offLineRecord' && !mode && ucPatientId && ucDoctorId"
        @click="uploadOffLineRecord"
        type="primary"
      >
        补充诊疗记录
      </a-button>
    </header>
    <!-- 表格 -->
    <a-table
      :loading="loading"
      class="table"
      :pagination="data.pagination"
      :rowKey="(record, index) => index"
      :columns="data.columns"
      :data-source="data.table"
      @showSizeChange="onPageOrSize"
      @change="onPageOrSize"
      show-quick-jumper
      :scroll="{ x: '100%', y: 'calc(100vh - 290px)' }"
    >
      <template #id="item">
        <div class="elip--multiple" style="-webkit-line-clamp: 2">
          {{ item.text || '--' }}
        </div>
      </template>
      <template #prescriptionDrug="{ record }">
        <div class="elip--multiple" style="-webkit-line-clamp: 2">
          <span v-if="record.instanceBusinessType === 1">
            {{ record.prescriptionName || '--' }}
          </span>
          <span v-else>{{ record.prescriptionDrug || '--' }}</span>
        </div>
      </template>
      <template #offlineDiagnosis="item">
        <div class="elip--multiple" style="-webkit-line-clamp: 2">
          {{ item.text || '--' }}
        </div>
      </template>
      <template #medicationNames="col">
        <span class="elip--multiple" style="-webkit-line-clamp: 2">
          {{ (col.text && col.text.map(item => item).join('；')) || '--' }}
        </span>
      </template>
      <template #diagnosisInfoList="{ record }">
        <span class="elip--multiple" style="-webkit-line-clamp: 2">
          {{ calcDiagnosis(record, 'diagnosisInfoList', 'diagnosisNames') }}
        </span>
      </template>
      <template #handle="data">
        <a-button class="button-link" type="link" @click="goDetail(data)">查看详情</a-button>
        <a-button
          v-if="getPermission(data.record, 'updatePermission')"
          type="link"
          @click="toEdit(data.record)"
        >
          编辑
        </a-button>
        <a-button
          danger
          v-if="getPermission(data.record, 'removePermission')"
          type="link"
          @click="deleteRecord(data.record)"
        >
          删除
        </a-button>
      </template>
    </a-table>
    <!-- 详情 -->
    <RecordDetail
      v-model:visible="visible"
      :recordType="recordType"
      :id="recordId"
      :mode="mode"
      :operateType="operateType"
      :pid="pid"
      :hospitalId="hospitalId"
      :ucPatientId="ucPatientId"
    />

    <!-- 门诊病历弹窗部分 -->
    <medicalRecordsPoup
      :visible="UploadRecordVisible"
      :params="query"
      :id="UploadRecordId"
      :isCanDelete="!!UploadRecordId"
      @cancelClick="onClose"
      @savaData="refreshOffLineRecord"
    ></medicalRecordsPoup>
    <!-- 检查单详情 -->
    <a-modal
      v-model:visible="chekcParams.visible"
      :width="1059"
      title="检查单详情"
      :bodyStyle="{
        padding: '16px 24px 18px 24px'
      }"
      :footer="null"
    >
      <checklistDetail
        :checklistId="chekcParams.checklistId"
        :visible="chekcParams.visible"
      ></checklistDetail>
    </a-modal>
  </div>
</template>

<style lang="scss" scoped>
.medical-record {
  height: 100%;
  .header {
    padding: 8px 20px;
    background: #f3f6fa;
    display: flex;
    justify-content: space-between;

    ::v-deep(.ant-radio-button-wrapper) {
      border-radius: 4px;
      border: 1px solid #999999;
      color: #999999;
      background: none;
    }

    ::v-deep(
        .ant-radio-group-solid
          .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)
      ) {
      background: none;
      border: 1px solid #1890ff;
      color: #1890ff;
    }
    ::v-deep(.ant-radio-button-wrapper:not(:first-child)::before) {
      display: none;
    }
  }
  .table {
    padding: 10px 20px 0;
    .button-link {
      padding: 0;
    }
  }
}
</style>
